import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '@xo-union/tk-component-icons';
import styles from './import-spreadsheet-error.scss';

const errorInSpreadsheet = errors => errors.names || errors.phone || errors.email;

const ImportSpreadsheetError = ({ errors, isProcessing }) => {
  if (isProcessing || !errorInSpreadsheet(errors)) return null;

  return (
    <div className={styles.errorMsg}>
      <Fragment>
        <Icon className={styles.warning} size="md" name="warning" />
        <span className={styles.validationMessage}>Oops! Please double-check any flagged rows.</span>
      </Fragment>
    </div>
  );
};

ImportSpreadsheetError.propTypes = {
  errors: PropTypes.shape({
    names: PropTypes.bool,
    phone: PropTypes.bool,
    email: PropTypes.bool,
  }),
  isProcessing: PropTypes.bool,
};

export default ImportSpreadsheetError;
